import axios from "axios";

const instance = axios.create({
    baseURL: window.NEWS_URLS.api
});

export const dataApi = {
    getUserRoles(){
        return instance.get("/getUserRoles")
                .then(resp => resp.data).catch(() => null);
    },
    getNotizia(not, s){
        return instance.get("/getNews", {
            params: {
                not: not || "new",
                s: s
            }
        }).then(response => response.data)
        .catch(err => Promise.reject(err.response));
    },
    save(model){
        return axios.post(window.NEWS_URLS.save, model, {
            headers: { "X-Requested-With": "XMLHttpRequest" }
        }).then(response => {
            let data = response.data;
            if(!data.success){
                return Promise.reject(data.errors);
            }
            return data;
        }).catch(err => {
            if(err.message){
                return Promise.reject(err.message);
            }
            return Promise.reject(err);
        });
    }
};


export function install(Vue){
    Vue.prototype.$dataApi = dataApi;
}
